import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Plus, Trash2, Check } from "lucide-react";

export const EventsTab = () => {
  const [list, setList] = useState([]);
  const [name, setName] = useState("");
  const [edits, setEdits] = useState({});
  const load = () => api.get("/events").then(({ data }) => setList(data || []));
  useEffect(() => { load(); }, []);
  const err = (e) => toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message);

  const add = async () => {
    if (!name.trim()) return;
    try { await api.post("/admin/events", { name }); setName(""); toast.success("Événement ajouté"); load(); } catch (e) { err(e); }
  };
  const rename = async (id) => {
    try { await api.put(`/admin/events/${id}`, { name: edits[id] }); setEdits((x) => ({ ...x, [id]: undefined })); toast.success("Renommé"); load(); } catch (e) { err(e); }
  };
  const remove = async (e) => {
    if (!window.confirm(`Supprimer « ${e.name} » ?`)) return;
    try { await api.delete(`/admin/events/${e.id}`); load(); } catch (x) { err(x); }
  };

  const events = list.filter((e) => e.kind === "event");
  const stocks = list.filter((e) => e.kind === "stock");
  return (
    <div className="grid md:grid-cols-2 gap-6" data-testid="events-tab">
      <div className="rounded-xl border border-border bg-card p-5 space-y-3">
        <h3 className="font-semibold">Événements</h3>
        <div className="flex gap-2">
          <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Ex. EQUITA 2026" data-testid="event-new-name"
            onKeyDown={(e) => e.key === "Enter" && add()} />
          <Button onClick={add} className="gap-1" data-testid="event-add"><Plus className="w-4 h-4" /> Ajouter</Button>
        </div>
        {events.length === 0 && <p className="text-sm text-muted-foreground">Aucun événement.</p>}
        {events.map((e) => (
          <div key={e.id} className="flex items-center gap-2" data-testid={`event-row-${e.id}`}>
            <Input value={edits[e.id] ?? e.name} onChange={(x) => setEdits((s) => ({ ...s, [e.id]: x.target.value }))} data-testid={`event-name-${e.id}`} />
            {edits[e.id] != null && edits[e.id] !== e.name && (
              <Button size="icon" variant="outline" onClick={() => rename(e.id)} data-testid={`event-save-${e.id}`}><Check className="w-4 h-4" /></Button>
            )}
            <Button size="icon" variant="ghost" className="text-destructive" onClick={() => remove(e)} data-testid={`event-delete-${e.id}`}><Trash2 className="w-4 h-4" /></Button>
          </div>
        ))}
      </div>
      <div className="rounded-xl border border-border bg-card p-5 space-y-2">
        <h3 className="font-semibold">Lieux de stockage des revendeurs</h3>
        <p className="text-xs text-muted-foreground">Créés automatiquement à partir de la commune de chaque revendeur (modifiable dans l'onglet Revendeurs).</p>
        <div className="flex flex-wrap gap-2 pt-1" data-testid="stock-list">
          {stocks.map((s) => <span key={s.id} className="text-xs rounded-md border border-border px-2 py-1">{s.name}</span>)}
        </div>
      </div>
    </div>
  );
};
